import React from 'react';
import PropTypes from 'prop-types';
import ArgomentiRadios from './ArgomentiRadios';
import AutocompleteArgomenti from './AutocompleteArgomenti';
import DatiAddizionali from './DatiAddizionali';
import InfoModaleQuesito from '../../Shared/InfoModaleQuesito';
import AvvisoContenutoEsclusivoPianoNonAttivo from '../shared/AvvisoContenutoEsclusivoPianoNonAttivo';
import AvvisoContenutoEsclusivoPianoSospeso from '../shared/AvvisoContenutoEsclusivoPianoSospeso';
import Riempimento from './Riempimento';
import usePianoEccellenza, { StatoCategoriaPDE, StatoUfficioPDE } from '../../Shared/Profilo/usePianoEccellenza';

/**
*/
const InformazioniAggiuntive = ({
  argomenti, etichettaCampoAux1, etichettaCampoAux2, ufficioSelezionato,
  argomento, onChangeArgomento, campoAux1, onChangeCampoAux1, campoAux2, onChangeCampoAux2,
}) => {
  const {
    statoUfficio,
    statoCategoria: statoArgomento,
  } = usePianoEccellenza(ufficioSelezionato, undefined, argomento);

  return (
    <div className="helpdesk-frontend-step helpdesk-frontend-informazioni-aggiuntive">
      <div className="helpdesk-frontend-informazioni-aggiuntive__main">
        {argomenti && argomenti.length > 0 && (
          <div className="helpdesk-frontend-informazioni-aggiuntive__argomento">
            {argomenti.length <= 6 && <ArgomentiRadios argomenti={argomenti} argomento={argomento} onChange={onChangeArgomento} />}
            {argomenti.length > 6 && <AutocompleteArgomenti argomenti={argomenti} argomento={argomento} onChange={onChangeArgomento} />}
          </div>
        )}
        <div className="helpdesk-frontend-informazioni-aggiuntive__dati-addizionali">
          <DatiAddizionali
            campoAux1={campoAux1}
            etichetta1={argomento ? argomento.EtichettaCampoAux1 : etichettaCampoAux1}
            onChangeCampo1={onChangeCampoAux1}
            campoAux2={campoAux2}
            etichetta2={argomento ? argomento.EtichettaCampoAux2 : etichettaCampoAux2}
            onChangeCampo2={onChangeCampoAux2}
          />
        </div>
        <Riempimento
          statoUfficio={statoUfficio}
          statoCategoria={statoArgomento}
        />
      </div>
      {
        statoArgomento === StatoCategoriaPDE.ESCLUSIVA_ECCELLENZA
        && statoUfficio === StatoUfficioPDE.PDE_SOSPESO
        && <AvvisoContenutoEsclusivoPianoSospeso />
      }
      {
        statoArgomento === StatoCategoriaPDE.ESCLUSIVA_ECCELLENZA
        && statoUfficio === StatoUfficioPDE.PIANO_QUALITA
        && <AvvisoContenutoEsclusivoPianoNonAttivo />
      }
      <InfoModaleQuesito infoModaleQuesito={argomento && argomento.InfoEvasione} />
    </div>
  );
};

InformazioniAggiuntive.propTypes = {
  ufficioSelezionato: PropTypes.string,
  argomenti: PropTypes.arrayOf(PropTypes.shape({
    IdCategoria: PropTypes.number.isRequired,
    Categoria: PropTypes.string.isRequired,
    EtichettaCampoAux1: PropTypes.string,
    EtichettaCampoAux2: PropTypes.string,
  })),
  etichettaCampoAux1: PropTypes.string,
  etichettaCampoAux2: PropTypes.string,

  onChangeArgomento: PropTypes.func.isRequired,
  argomento: PropTypes.shape({
    IdCategoria: PropTypes.number,
    EtichettaCampoAux1: PropTypes.string,
    EtichettaCampoAux2: PropTypes.string,
    InfoEvasione: PropTypes.string,
    EsclusivaEccellenza: PropTypes.bool,
  }),

  onChangeCampoAux1: PropTypes.func.isRequired,
  campoAux1: PropTypes.string,

  onChangeCampoAux2: PropTypes.func.isRequired,
  campoAux2: PropTypes.string,
};

InformazioniAggiuntive.defaultProps = {
  ufficioSelezionato: undefined,
  etichettaCampoAux1: undefined,
  etichettaCampoAux2: undefined,
  argomenti: undefined,
  argomento: undefined,
  campoAux1: '',
  campoAux2: '',
};

export default InformazioniAggiuntive;
